// extracted by mini-css-extract-plugin
module.exports = {"topic":"index-topic-1l5Qv","collectionHeader":"index-collectionHeader-sUeZF","menulist":"index-menulist-2rjqC","light":"index-light-16VqU"};